import React, { useState } from 'react';
import Typography from '../components/v2/Typography';
import Button from '../components/v2/Button';
import { Download, ArrowRight, Search, Menu, SearchIcon, Globe, InfoIcon, CheckIcon } from 'lucide-react';
import DomainCard from '../components/v2/DomainCard';
import IButton from '../components/v2/IButton';
import Input from '../components/v2/Input';
import Textarea from '../components/v2/TextArea';
import { Link } from 'react-router-dom';
import Faq, { faqData } from '../atoms/Faq';
import BlogSection from '../atoms/BlogPreview';
import useApp from '../hooks/useApp';

const ContactSection = () => {

    const appCtx = useApp();

    return (
      <section className='contact-section'>
        <div className="contact-wrapper">
          <div className="inner">
            {/* <div className="contact-heading">
          <Typography variant="h1">About Us</Typography>
        </div> */}
            <div className="contact-content">
              <div className="contact-row">
                <div className="contact-heading">
                  <Typography variant="h1">About Us</Typography>
                </div>
                <div className="contact-info">
                  <Typography variant="para">We are a premium domain name brokerage, acquisition, and consulting firm.<br /><br />Companies and investors regularly use NameConnect brokers to approach domain owners with an educated offer as industry leaders, we act discreetly in the hopes of attaining you the best price for your new investment while assessing the true value of the asset you’re targeting.<br /><br />NameConnect.com also acts as consultants for their clients, we broker seven figures in domains each year and can assist with your portfolio as well.</Typography>
                </div>
                {/* <div className="contact-controls contact-controls-pc">
              <Button variant='primary-2' leftIcon={Globe} rightIcon={ArrowRight}>Find your domain value</Button>
              <Button variant='primary-2' leftIcon={SearchIcon} rightIcon={ArrowRight}>Find WHOIS information</Button>
              <Button variant='primary' leftIcon={InfoIcon} rightIcon={ArrowRight}>Talk to our Team</Button>
            </div> */}
                {appCtx.testinomialsList && appCtx.testinomialsList.length > 0 && <div className="contact-people">
                  <div className="contact-people-avatar">
                    <img src={(appCtx.testinomialsList[0].picture || {})['original']} alt="" />
                  </div>
                  <div className="contact-people-info">
                    <div className="contact-people-name">
                      <Typography variant="para">{appCtx.testinomialsList[0].name}</Typography>
                    </div>
                    <div className="contact-people-desc">
                      <Typography variant="para">{appCtx.testinomialsList[0].review}</Typography>
                    </div>
                  </div>
                </div>}
              </div>
              <div className="contact-row">
  
                <form onSubmit={(e) => {
                  e.preventDefault();
                  console.log(e.target);
                  appCtx.submitForm(e.target.name.value, e.target.email.value, e.target.phone.value, e.target.query.value);
                }} className="contact-form">
                  <div className="inner">
  
                    <div className="form-heading">
                      <Typography variant="h3">Get a Callback</Typography>
                    </div>
  
                    <div className="form-content">
                      <div className="form-control">
                        <div className="form-name">
                        <Typography variant="para">Name</Typography>
                      </div>
                        <Input name="name" label="" placeholder="John Doe" type="text" value="" onChange={() => { }} />
                      </div>
  
                      <div className="form-control">
                      <div className="form-name">
                        <Typography variant="para">Phone number</Typography>
                      </div>
                        <Input name="phone" placeholder="+1 123456789" type="number" value="" onChange={() => { }} />
                      </div>
  
                      <div className="form-control">
                      <div className="form-name">
                        <Typography variant="para">Email</Typography>
                      </div>
                        <Input name="email" placeholder="johndoe@gmail.com" type="email" value="" onChange={() => { }} />
                      </div>
  
                      <div className="form-control">
                        <div className="form-name m">
                          <Typography variant="para">Query</Typography>
                        </div>
                        <Textarea name="query" label="" value="" onChange={() => { }} style={{height: 170}} />
                      </div>
  
                      <div className="form-control submit-btn-container">
                        <Button type="submit" className='button-full' variant="primary">
                          <Typography variant="button">Submit</Typography>
                        </Button>
                      </div>
                    </div>
  
                  </div>
                </form>
  
              </div>
            </div>
          </div>
        </div>
        </section>
    );
  }
  
  export default ContactSection;